import { palette } from "../palette";
export const button = {
  global: {
    borderRadius: "4px",
    minWidth: "184px"
  },
  disabled: {
    color: palette.gray.lighter,
    cursor: "default",
    backgroundColor: palette.gray.lightest,
    boxShadow: "none",
    padding: "9px 8px",
    borderWidth: 0
  },
  primary: {
    color: palette.white,
    backgroundColor: palette.action.primary,
    borderWidth: 0,
    padding: "9px 8px",
    hover: {
      color: palette.white,
      backgroundColor: palette.action.darker
    }
  },
  primaryReverse: {
    color: palette.black,
    backgroundColor: palette.white,
    borderWidth: 0,
    padding: "9px 8px",
    hover: {
      color: palette.black,
      backgroundColor: palette.white
    }
  },
  secondary: {
    color: palette.action.primary,
    backgroundColor: "transparent",
    borderColor: palette.action.primary,
    borderWidth: "2px",
    padding: "7px 8px",
    hover: {
      color: palette.white,
      backgroundColor: palette.action.darker,
      borderColor: palette.action.darker
    }
  },
  secondaryReverse: {
    color: palette.white,
    backgroundColor: "transparent",
    borderColor: palette.white,
    borderWidth: "2px",
    padding: "7px 8px",
    hover: {
      color: palette.black,
      backgroundColor: palette.white
    }
  },
  tertiary: {
    color: palette.black,
    backgroundColor: palette.white,
    borderColor: palette.gray.primary,
    borderWidth: "1px",
    padding: "8px 8px",
    hover: {
      color: palette.black,
      backgroundColor: palette.white,
      borderWidth: 0,
      padding: "9px 8px"
    }
  },
  link: {
    color: palette.action.primary,
    backgroundColor: "transparent",
    borderWidth: 0,
    padding: "9px 8px",
    minWidth: "initial",
    hover: {
      color: palette.action.darker,
      backgroundColor: "transparent",
      borderWidth: 0,
      boxShadow: "none",
      padding: "9px 8px",
      textDecoration: "underline"
    },
    disabled: {
      backgroundColor: "transparent"
    }
  },
  linkReverse: {
    color: palette.white,
    backgroundColor: "transparent",
    borderWidth: 0,
    padding: "9px 8px",
    minWidth: "initial",
    hover: {
      color: palette.white,
      backgroundColor: "transparent",
      borderWidth: 0,
      boxShadow: "none",
      padding: "9px 8px",
      textDecoration: "underline"
    },
    disabled: {
      backgroundColor: "transparent"
    }
  },
  destroy: {
    color: palette.red.primary,
    backgroundColor: "transparent",
    borderColor: palette.red.primary,
    borderWidth: "2px",
    padding: "7px 8px",
    hover: {
      color: palette.white,
      backgroundColor: palette.red.primary,
      borderWidth: 0,
      padding: "9px 8px"
    }
  },
  destroyReverse: {
    color: palette.white,
    backgroundColor: "transparent",
    borderColor: palette.white,
    borderWidth: "2px",
    padding: "7px 8px",
    hover: {
      color: palette.red.primary,
      backgroundColor: palette.white,
      borderWidth: 0,
      padding: "9px 8px"
    }
  }
};